import { WeekdayMap } from '@services/appsync/mappings';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const createUTCDate = (input?: string | Date, format?: string): Date => {
  return dayjs.utc(input, format).toDate();
};

export const getDaysFromDate = (date: string, days: number, fmt = 'YYYY-MM-DD') => {
  if (days === 0) return dayjs(date).format(fmt);
  const d = new Date(date);
  d.setDate(d.getDate() + days + 1);
  return dayjs(d).format(fmt);
};

export const getToday = (format = 'YYYY-MM-DD') => {
  return dayjs().format(format);
};

export const addWeeks = (date: Date, weeks: number) => {
  return dayjs(date).add(weeks, 'week').toDate();
};

export const addMonths = (date: string, months: number, format = 'YYYY-MM-DD'): string => {
  return dayjs(date).add(months, 'month').format(format);
};

export const getWeekBySubtractingWeeks = (date: Date, numOfWeeks: number) => {
  if (numOfWeeks === 0) return dayjs(createUTCDate(date)).toDate();
  const d = new Date(date);
  return dayjs(d).subtract(numOfWeeks, 'weeks').toDate();
};

export const getMonthBySubtractingMonths = (date: Date, numOfMonths: number) => {
  if (numOfMonths === 0) return dayjs(createUTCDate(date)).toDate();
  const d = new Date(date);
  return dayjs(d).subtract(numOfMonths, 'month').toDate();
};

export const getMonthNameByMonthNumber = (num: number, fmt: 'abbr' | 'full' = 'full') => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return fmt === 'full' ? months[num] : months[num].slice(0, 3);
};

export const getDaysDiff = (from: Date, to = new Date()) => {
  return dayjs(to).diff(dayjs(from), 'days');
};
export const getYearsDiff = (from: Date, to = new Date()) => {
  return dayjs(to).diff(dayjs(from), 'years');
};

export const formatDate = (date: Date, format = 'YYYY-MM-DD') => {
  return dayjs(date).format(format);
};

export const createDateFromShortISO = (dateString: string) => {
  const date = new Date();
  const splitDate = dateString.split('-');
  date.setFullYear(parseInt(splitDate[0]));
  date.setMonth(parseInt(splitDate[1]) - 1);
  date.setDate(parseInt(splitDate[2]));
  return date;
};

export const getDayNameByNumber = (dayNumber: number) => {
  switch (dayNumber) {
    case WeekdayMap.MONDAY:
      return 'Monday';
    case WeekdayMap.TUESDAY:
      return 'Tuesday';
    case WeekdayMap.WEDNESDAY:
      return 'Wednesday';
    case WeekdayMap.THURSDAY:
      return 'Thursday';
    case WeekdayMap.FRIDAY:
      return 'Friday';
    case WeekdayMap.SATURDAY:
      return 'Saturday';
    case WeekdayMap.SUNDAY:
      return 'Sunday';
    default:
      return 'Monday';
  }
};

export const getMonthsFirstDay = (date: string | null, format = 'YYYY-MM-DD') => {
  const current = dayjs(date).set('date', 1);
  if (!current.isValid()) return null;
  return current.format(format);
};

export const isValidDate = (date: string | null) => {
  return dayjs(date).isValid();
};
